// DOM helpers for applying brand identity beyond MUI (favicon, title)

export function updateFaviconAndTitle(branding) {
  if (typeof document === 'undefined') return;
  try {
    const { companyName, logo } = branding || {};
    // Title
    if (companyName && typeof companyName === 'string') {
      document.title = `${companyName} • LYS Artisans`;
    } else {
      document.title = 'LYS Artisans';
    }

    // Favicon
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    if (logo) {
      link.href = logo;
    } else {
      // fallback to default if any existing
      // no-op: keep previous favicon if default is handled elsewhere
    }
  } catch (e) {
    // ignore DOM errors silently
  }
}
